module.exports = __webpack_public_path__ + "static/media/history_5.0b6578c1.jpg";